/* global ATHOM_ACCOUNTS_BASE_URL */

import React from "react";
import {userManager} from "../../managers/UserManager";
import {i18nFormat} from "../../lib/i18nFormat";

export function AccountPage() {
  const user = userManager.store(state => state.user); // User is updated on state change.

  const editAccountUrl = ATHOM_ACCOUNTS_BASE_URL;
  // TODO: Use these URLs when login errors are fixed.
  // const editProfileUrl = `${ATHOM_ACCOUNTS_BASE_URL}/login?profile=${user.id}`;
  // const changePasswordUrl = `${ATHOM_ACCOUNTS_BASE_URL}/login?profile=${user.id}#password-reset`;
  // const manage2FAUrl = `${ATHOM_ACCOUNTS_BASE_URL}/login?profile=${user.id}`;

  return (
    <section className="account-page account-account">
      <header className="account-page__header">
        <h1 className="account-page__title">{i18nFormat("account.title")}</h1>
        <p className="account-page__text">{i18nFormat("account.subtitle")}</p>
      </header>
      <div className="account-page__content">
        <div className="account-account__section">
          <div className="account-account__section-heading">
            <h2 className="account-account__section-title">{i18nFormat("account.personal-details.title")}</h2>
          </div>
          <div className="account-account__section-content">
            <div className="account-account__item">
              <div className="account-account__personal-details">
                <img className="account-account__personal-details-avatar" src={user.avatar.medium}
                     srcSet={`${user.avatar.large} 2x`} alt={"Account avatar"}/>
                <div className="account-account__personal-details-info">
                  <h3 className="account-account__personal-details-name">{user.fullname}</h3>
                  <p className="account-account__personal-details-email">{user.email}</p>
                </div>
              </div>
              <a className="account-account__item-link" href={editAccountUrl}
                 target="_blank" rel="noopener noreferrer">
                <span>{i18nFormat("account.personal-details.link")}</span>
                <span className="glyph-core-square-arrow-up-right"/>
              </a>
            </div>
          </div>
        </div>
        <div className="account-account__section">
          <div className="account-account__section-heading">
            <h2 className="account-account__section-title">{i18nFormat("account.security.title")}</h2>
          </div>
          <div className="account-account__section-content">
            <div className="account-account__item">
              <span className="account-account__item-label">{i18nFormat("account.security.password")}</span>
              <a className="account-account__item-link"
                 href={editAccountUrl} target="_blank"
                 rel="noopener noreferrer">
                <span>{i18nFormat("account.security.password-link")}</span>
                <span className="glyph-core-square-arrow-up-right"/>
              </a>
            </div>
            <div className="account-account__item">
              <span className="account-account__item-label">{i18nFormat("account.security.2fa")}</span>
              <a className="account-account__item-link" href={editAccountUrl}
                 target="_blank" rel="noopener noreferrer">
                <span>{i18nFormat(`account.security.${user.otpEnabled ? "disable-2fa" : "enable-2fa"}`)}</span>
                <span className="glyph-core-square-arrow-up-right"/>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}